export const splitOneLineBillingAddress = (
  oneLineAddress?: string,
  postcode?: string
) => {
  if (!oneLineAddress) return;

  return oneLineAddress
    .split(',')
    .map((item) => item.trim())
    .filter((line) => line !== postcode);
};
